import React, { useState } from "react";
import { MuiBox } from "../../components";
import { PAGE_IDS } from "../../helpers/constants";
import { useSiteCore } from "../../hooks/useSiteCore";
import BulkCreateProgram from "../bulkCreateProgram/BulkCreateProgram";
import { BulkEditHeader } from "./components/bulkEditHeader/BulkEditHeader";
import { BulkEditSearchParticipant } from "./components/bulkEditSearchParticipant/BulkEditSearchParticipant";
import BulkEditTypeSelect from "./components/bulkEditTypeSelect/BulkEditTypeSelect";
import { bulkEditHeaderFooterSiteCoreKeys } from "./siteCore/siteCoreKeys";

interface BulkEditProgramProps {
  initialStep?: number;
  status?: string;
  bulkImportId?: string;
  pageId?: string;
  isEditViewOnly?: boolean;
}

const BulkEditProgram: React.FC<BulkEditProgramProps> = ({
  initialStep,
  status,
  bulkImportId,
  pageId = PAGE_IDS.BULK_EDIT_PROGRAM,
  isEditViewOnly,
}) => {
  const [currentStep, setCurrentStep] = useState(isEditViewOnly ? 2 : 0);
  const { useFetchLabel } = useSiteCore();
  const getLabel = useFetchLabel(
    bulkEditHeaderFooterSiteCoreKeys.headerAndFooterComponent,
  );
  const handleStepChange = (nextStep: number) => {
    setCurrentStep(nextStep);
  };

  const renderStep = () => {
    if (isEditViewOnly) {
      return (
        <BulkCreateProgram
          isEditBulkProgram={true}
          isEditViewOnly={isEditViewOnly}
          status={status}
          bulkImportId={bulkImportId}
          stepValue={initialStep}
          pageId={pageId}
        />
      );
    }

    switch (currentStep) {
      case 0:
        return <BulkEditTypeSelect onContinue={handleStepChange} />;
      case 1:
        return (
          <BulkEditSearchParticipant
            pageId={pageId}
            setEditCurrentStep={setCurrentStep}
          />
        );
      case 2:
        return (
          <BulkCreateProgram
            isEditBulkProgram={true}
            setEditCurrentStep={setCurrentStep}
          />
        );
      default:
        return null;
    }
  };

  const getSubHeader = () => {
    switch (currentStep) {
      case 0:
        return "";
      case 1:
        return getLabel(
          bulkEditHeaderFooterSiteCoreKeys.chooseParticipantsAndDownloadTemplateTypeSubTitle,
        );
      case 2:
        return getLabel(
          bulkEditHeaderFooterSiteCoreKeys.uploadModifiedTemplateTypeSubTitle,
        );
      default:
        return "";
    }
  };

  return (
    <MuiBox>
      <BulkEditHeader subTitle={getSubHeader()} />
      {renderStep()}
    </MuiBox>
  );
};

export default BulkEditProgram;
